import styled from 'styled-components';
import themeData from 'utils/theme/themeData';

const { typography } = themeData;

export const PaginationWrapper = styled.div`
  display: flex;
  justify-content: center;

  & > * + * {
    margin-inline-start: 4px !important;
  }
`;

export const PaginationPageNumberItem = styled(typography.BodyTextOneRegularTypography)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  margin: 0;
  color: ${({ theme }) => theme.colors.black};
  background-color: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.grey003};
  border-radius: 4px;
  box-sizing: border-box;
  cursor: pointer;

  ${({ selected, theme }) =>
    selected &&
    `
      background-color: ${theme.colors.grey003};
  `}
`;

export const PaginationDotsItem = styled(typography.BodyTextOneRegularTypography)`
  display: flex;
  align-items: flex-end;
  margin: 0;
  padding: 8px 7px;
  color: ${({ theme }) => theme.colors.black};
`;
